module.exports = __webpack_public_path__ + "img/bodycheck6.ab292252.jpg";